import { useState } from "react";
import useTranslator from "../../hooks/useTranslator";
import FreshFruitRunningTotals from "./components/FreshFruitRunningTotals";
import ColdRoomDataOverview from "./components/ColdRoomDataOverview";
import BiggestDaily from "./components/BiggestDaily";
import PackingProcessingHeader from "./components/PackingProcessing/PackingProcessingHeader";
import PackingMetricCards from "./components/PackingProcessing/PackingMetricCards";
import PackingShifts from "./components/PackingProcessing/PackingShifts";
import BrokeringDay from "./components/PackingProcessing/BrokeringDay";
import "./components/dashboard-sections.css";
import { getCurrentDate } from "../../helpers/Utils";

const Dashboard = () => {
  const { _t } = useTranslator();
  const [period, setPeriod] = useState("daily");
  const [packingDate, setPackingDate] = useState(getCurrentDate("YYYY-MM-DD"));

  // Set to true to preview shimmer loading state
  const isLoading = false;

  const periods = [
    { key: "daily",   label: _t("daily",   "Daily")   },
    { key: "weekly",  label: _t("weekly",  "Weekly")  },
    { key: "monthly", label: _t("monthly", "Monthly") },
  ];

  return (
    <div>
      <div className="db-header">
        <div className="db-header-title">
          <h2>{_t("dashboard_title", "Off The Tree Dashboard")}</h2>
          <p>{_t("dashboard_subtitle", "Real-time supply chain and maturity metrics overview")}</p>
        </div>
        <ul className="db-period-toggle">
          {periods.map((p) => (
            <li
              key={p.key}
              className={period === p.key ? "active" : ""}
              onClick={() => setPeriod(p.key)}
            >
              {p.label}
            </li>
          ))}
        </ul>
      </div>
      
      <BiggestDaily isLoading={isLoading} />
      <FreshFruitRunningTotals isLoading={isLoading} />
      <ColdRoomDataOverview isLoading={isLoading} />

      {/* ── Packing & Processing ── */}
      <div className="db-section">
        <PackingProcessingHeader
          date={packingDate}
          onDateChange={setPackingDate}
          onExport={() => {}}
        />
        <PackingMetricCards isLoading={isLoading} />
        <PackingShifts isLoading={isLoading} />
        <BrokeringDay isLoading={isLoading} />
      </div>
    </div>
  );
};

export default Dashboard;